<template>
    <div>
        <b-modal id="add-edit-appointment" hide-footer @hidden="closeModal">
            <template v-slot:modal-header="{  }">
                <template v-if="type==='form'">
                    <h4 v-if="!isProject">{{isNew ? 'New' : 'Edit'}} appointment <b-badge v-if="isPartOfProject" pill variant="success">Project</b-badge></h4>
                    <h4 v-if="isProject">New project appointments</h4>
                </template>
                <template v-if="type==='log'">
                    <h4>History appointment {{appointment.id_appointment}}</h4>
                </template>
            </template>
            <template v-slot:default="{  }">
                <form v-if="type==='form'" @submit.prevent>
                    <loader :loading="loading">
                        <div class="row mb-3" v-if="isProject || isPartOfProject">
                            <div class="col-xl-6 col-lg-6">
                                <label>From</label>
                                <datepicker @input="onChangeDate" v-model="$v.appointment.date_start.$model" format="dd/MM/yyyy" input-class="form-control false-disabled"></datepicker>
                            </div>
                            <div class="col-xl-6 col-lg-6">
                                <label>To</label>
                                <datepicker @input="onChangeDate" v-model="$v.appointment.date_end.$model" format="dd/MM/yyyy" input-class="form-control false-disabled"></datepicker>
                            </div>
                        </div>
                        <div class="row mb-3" v-if="!isNew">
							<div class="col-xl-6 col-lg-6" v-if="!isPartOfProject">
								<label>Date</label>
								<datepicker @input="onChangeDate" v-model="$v.appointment.date.$model" format="dd/MM/yyyy" input-class="form-control false-disabled"></datepicker>
							</div>
                            <div class="col-xl-6 col-lg-6">
                                <label>Employee</label>
                                <select class="form-control" v-model="$v.appointment.id_employee.$model">
                                    <option v-for="e in employees" :value="e.id_employee" :key="e.id_employee">{{e.first_name+' '+e.last_name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-4 col-lg-4">
                                <fg-input type="text" label="Time" placeholder="Time" 
                                :class="{'has-error':$v.appointment.time.$error}"
                                v-model="$v.appointment.time.$model"></fg-input>
                            </div>
                            <div class="col-xl-8 col-lg-8">
                                <label>Client</label>
                                <tags-input  id="client-tag"
                                wrapper-class="form-control"
                                    v-model="selected_tag_client"
                                    :class="{'has-error':$v.appointment.id_client.$error}"
                                    typeahead-style="dropdown"
                                    :limit="1"
                                    placeholder="Client"
                                    :typeahead-hide-discard="true"
                                    :typeahead-activation-threshold="2"
                                    :only-existing-tags="true"
                                    :existing-tags="clients_as_tags"
                                    :typeahead="true"
                                    :limit-rached="true"
                                    @tag-added="onTagAdded()" @tag-removed="onTagRemoved()">
                                </tags-input>
                                <router-link target="_blank" to="/clients/new"><small>Add new client</small></router-link>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-12 col-lg-12">
                                <fg-input type="text" label="Address" placeholder="Address"
                                :class="{'has-error':$v.appointment.address.$error}"
                                v-model="$v.appointment.address.$model"></fg-input>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-xl-12 col-lg-12">
                                <label>Detail</label>
                                <textarea class="form-control"
                                :class="{'has-error':$v.appointment.detail.$error}"
                                v-model="$v.appointment.detail.$model"></textarea>
                            </div>
                            <!--<div class="col-xl-6 col-lg-6">
                                <fg-input type="text" label="Reference" placeholder="Reference"
                                :class="{'has-error':$v.appointment.reference.$error}"
                                v-model="$v.appointment.reference.$model"></fg-input>
                            </div>-->
                        </div>
                        <div class="row">
                            <div class="col-xl-6 col-lg-6">
                                <label>Category</label>
                                <select class="form-control" v-model="$v.appointment.id_category.$model">
                                    <option v-for="c in categories" :value="c.id_category" :key="c.id_category">{{c.name}}</option>
                                </select>
                            </div>
                            <div class="col-xl-6 col-lg-6" v-if="!isNew && $store.getters.isAdmin">
                                <label>State</label>
                                <select class="form-control" v-model="$v.appointment.id_state.$model" >
                                    <option v-for="s in status" :value="s.id_state" :key="s.id_state">{{s.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-3">
                             <div class="col-xl-12 col-lg-12">
                                <fg-input type="text" label="Note" placeholder="Note"
                                :class="{'has-error':$v.appointment.note.$error}"
                                v-model="$v.appointment.note.$model"></fg-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-xl-6 col-lg-6">
                                <b-form-checkbox v-model="$v.appointment.printable.$model" :value="1" :unchecked-value="0">Printable</b-form-checkbox>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-2 text-left">
								<p-button  type="link" round  @click.native.prevent="closeModal()">Back</p-button>
							</div>
                            <div class="col-10 text-right">
                                <p-button v-if="!isNew && !isModified && canPrint" round class="btn btn-success btn-sm" @click.native.prevent="printAppointment()">Print</p-button>
                                <p-button v-if="!isNew" round class="btn btn-success btn-sm" @click.native.prevent="type='log';loadAppointmentLog()">History</p-button>
                                <p-button v-if="!isNew && !isModified" :loading="loading_delete" @click.native.prevent="deleteAppointment()" round class="btn btn-danger btn-sm">Delete</p-button>
                                <p-button v-if="!isNew && !isModified && isPartOfProject" :loading="loading_delete" @click.native.prevent="deleteProject()" round class="btn btn-danger btn-sm">Delete project</p-button>
                                <p-button v-if="isModified" :loading="loading_save" @click.native.prevent="beforeSaveAppointment()" round class="btn btn-success btn-sm">Save</p-button>
                                <p-button v-if="isModified && isPartOfProject" :loading="loading_save" @click.native.prevent="updateProject()" round class="btn btn-success btn-sm">Save project</p-button>
                            </div>
                        </div>
                    </loader>
                </form>
                <template v-if="type==='log'">
                    <div class="row">
                        <div class="col-12">
                            <b-table responsive striped hover
					            :items="log" :fields="columns_log" :busy='loading_log' show-empty>
						        <template v-slot:table-busy>
							        <loader :loading="loading_log"></loader>
						        </template>
				            </b-table>
                        </div>   
                    </div>
                    <div class="row mt-4">
                        <div class="col-4 text-left">
							<p-button  type="link" round  @click.native.prevent="type='form'">Back</p-button>
						</div>
                    </div>
                </template>
            </template>
            
        </b-modal>
    </div>

    
</template>

<script>

import {required} from 'vuelidate/lib/validators';
import Datepicker from 'vuejs-datepicker';
import VoerroTagsInput from '@voerro/vue-tagsinput';

import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts"

import {helper_pdf} from '../../helper/pdf';

export default {
    components:{
        Datepicker,
        'tags-input':VoerroTagsInput
    },
    props:{
        appointment:Object,
        //clients:Array,
        client:Object,
        categories:Array,
        status:Array,
        appointments:Array,
        employee:Object,
        employees:Array,
        day:Object,
        loading:Boolean
    },
    data(){
        return{
            clients:[],
            show_print:false,
            proxyClient:[],
            loading_save:false,
            loading_delete:false,
            loading_log:false,
            log:[],
            columns_log:[
                {
                    key:'date',
                    label:'Date',
                    formatter:(value)=>{
						return this.$moment(value).format('DD/MM/YYYY HH:mm:ss')
					}
                },
                {
                    key:'user',
                    label:'User',
                    formatter:function(val){
                        return val.username
                    }
                },
                {
                    key:'action',
                    label:'Action'
                }
            ],
            type:'form'
        }
    },
    validations:{
		appointment:{
            date:{required},
            id_employee:{required},
            date_start:{},
            date_end:{},
            time:{required},
            id_client:{required},
            reference:{},
            detail:{},
            address:{required},
            note:{},
            id_category:{required},
            id_state:{required},
            printable:{required}
	  	}
  	},
    computed:{
        clients_as_tags(){
            this.clients.forEach(c => {
                let str_client = c.first_name+' '+c.last_name;
                if(c.telephone_number!=null){
                    str_client+=' - '+c.telephone_number
                }
                this.$set(c,'value',str_client); 
            });
            return this.clients;
        },
        selected_tag_client:{
            get(){
                let found = undefined;
                if(!this.isNew){
                    if(this.client && this.clients.length<1){
                        let c = this.client;
                        let str_client = c.first_name+' '+c.last_name;
                        if(c.telephone_number!=null){
                            str_client+=' - '+c.telephone_number
                        }
                        this.$set(c,'value',str_client);
                        found = c
                    }
                    else{
                        found = this.clients_as_tags.find(c=>{   
                            return c.id_client == this.appointment.id_client;
                        }); 
                    }
                }
                return found!=undefined ? [found] : this.proxyClient;
            },
            set(newVal){
                this.proxyClient = newVal
            }
        },
        isNew(){
            return this.appointment.id_appointment===null
        },
        isModified(){
            return this.$v.$anyDirty;
        },
        isProject(){
            return this.appointment.is_project;
        },
        isPartOfProject(){
            return this.appointment.id_project!==null;
        },  
    },
    methods:{
        async onChangeValueClient() {
           
                let input = document.getElementById('client-tag').firstChild.firstChild
                let value = input.value;
                if(value.length>2){
                    input.setAttribute('disabled',true);
                    let result = await this.$api.get('client?where=first_nameLIKE%'+value+'%,||last_nameLIKE%'+value+'%&fields=id_client,first_name,last_name,address,telephone_number');
                    this.clients = result.data;
                    input.removeAttribute('disabled');
                    input.focus();
                }
           
        },
        canPrint(){
			let found = this.employee.departments.find(d=>{
				return d.id_department===2 || d.id_department===4
            });
			return !!found && this.appointment.printable;
		},
        onTagAdded(){
            if(this.appointment.id_client!==this.selected_tag_client[0].id_client){
                this.$v.appointment.id_client.$model = this.selected_tag_client[0].id_client;
                this.$v.appointment.address.$model = this.selected_tag_client[0].address;
            }
            let tag_input = document.getElementById('client-tag');
            tag_input.firstChild.children[1].setAttribute('style','display:none');
        },
        onTagRemoved(){
            let tag_input = document.getElementById('client-tag');
            tag_input.firstChild.children[0].removeAttribute('style');
            this.$v.appointment.id_client.$model = null;
            this.$v.appointment.address.$model = null;
        },
        closeModal(){
            this.$v.appointment.$reset();
            this.type = 'form';
            this.selected_tag_client = [];
            this.$bvModal.hide('add-edit-appointment');
            this.$router.replace({'query': null}).catch(err=>{});
        },
        onChangeDate(){
            this.appointment.date_start = this.$moment(this.appointment.date_start).format('YYYY-MM-DD');
            this.appointment.date_end = this.$moment(this.appointment.date_end).format('YYYY-MM-DD');
            this.appointment.date = this.$moment(this.appointment.date).format('YYYY-MM-DD');
        },
        onChangeClient(event){
            let found = this.clients.find(c=>{
                return c.id_client == event.target.value
            });
            if(found!==undefined){
                this.appointment.address = found.address;
            }
        },
        async getAppointment(id){
            let result = await this.$api.get('appointment/'+id+'?join=client,state');
            return result.data;
        },
        async deleteAppointment(){
            this.loading_delete = true;
            let result = await this.$api.delete('appointment/'+this.appointment.id_appointment);
            this.$toast.error({
                message:'Appointment deleted',
                icon: "ti-check"
            });
            let e_delete = this.appointments.find(e=>{
                return e.id_appointment === result.data.id_appointment;
            });
            this.appointments.splice(this.appointments.indexOf(e_delete),1);
            this.loading_delete = false;
            this.closeModal();
        },
        async deleteProject(){
            this.loading_delete = true;
            let result = await this.$api.get('appointment?fields=id_appointment&where=id_project='+this.appointment.id_project);
            let app_project = result.data;
            for(let i=0;i<app_project.length;i++) {
                await this.$api.delete('appointment/'+app_project[i].id_appointment);
            }
            let e_delete = this.appointments.find(e=>{
                return e.id_appointment === result.data.id_appointment;
            });
            this.appointments.splice(this.appointments.indexOf(e_delete),1);
            this.$toast.error({
                message:'Project deleted',
                icon: "ti-check"
            });
            this.loading_delete = false;
            this.closeModal();
        },
        async beforeSaveAppointment(){
            this.loading_save = true;
            let available_slots = await this.$api.get('employee/s/available-slots/'+this.appointment.date+'/'+this.appointment.id_employee);
            if(available_slots.data<=0 && (this.appointment.date!==this.appointment.current_date || this.appointment.id_employee!==this.appointment.current_id_employee)){
                let self = this;
                this.$toast.question({
                    message:'There are not slots available! Proceed to save?',
                    icon: "fas fa-exclamation-triangle",
                    close: false,
                    overlay: true,
                    buttons: [
                        ['<button><b>YES</b></button>', function (instance, toast) {
                            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                            self.saveAppointment();
                        }],
                        ['<button>NO</button>', function (instance, toast) {
                            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                            self.loading_save = false;
                        }],
                    ],
                    onClosing:function(){
                        self.loading_save = false;
                    }
                });
            }
            else{
                this.saveAppointment()
            }
        },
        async saveAppointment(){
            this.$v.appointment.$touch();
            this.loading_save = true;

            if(!this.$v.appointment.$invalid){

                if(!this.isProject){
                    if(this.isNew){
                        this.appointment._created_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                        let result = await this.$api.post('appointment',this.appointment);
                        this.appointment.id_appointment = result.data.id_appointment;
                        this.$set(this.appointment,'current_date',this.appointment.date);
				        this.$set(this.appointment,'current_id_employee',this.appointment.id_employee);
                        this.appointments.push(await this.getAppointment(this.appointment.id_appointment));
                    }
                    else{
                        let result = await this.$api.put('appointment/'+this.appointment.id_appointment,this.appointment);
                        let e_update = this.appointments.find(e=>{
                            return e.id_appointment === this.appointment.id_appointment;
                        });
                        let update = await this.getAppointment(this.appointment.id_appointment);
                        
                        if(this.appointment.current_date != this.appointment.date || this.appointment.current_id_employee != this.appointment.id_employee){
                             this.appointments.splice(this.appointments.indexOf(e_update),1);
                             this.closeModal();
                        }
                        else{
                            this.appointments.splice(this.appointments.indexOf(e_update),1,update);
                        }

                        this.appointment.current_date = this.appointment.date;
				        this.appointment.current_id_employee = this.appointment.id_employee;
                    }

                    this.$toast.success({
                        message:this.isNew ? 'Appointment added' : 'Appointment edited',
                        icon: "ti-check"
                    });
                }

                else{
                    let start = this.appointment.date_start;
                    let id_project = this.$moment().unix();
                    this.appointment._created_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                    while(start <= this.appointment.date_end){
                        this.appointment.date = start;
                        if(this.$moment(start).weekday()!==5 && this.$moment(start).weekday()!==6){
                            this.appointment.id_project = id_project;
                            let result = null;
                            let temp_appointment = this.appointment;
                            for(let i=0;i<this.employee.slots;i++){
                                if(i!=0){
                                    temp_appointment.fake = 1
                                }
                                else{
                                    temp_appointment.fake = 0
                                }
                                result = await this.$api.post('appointment',temp_appointment);
                            }
                            if(this.appointment.date == this.$route.params.date){
                                this.appointments.push(await this.getAppointment(result.data.id_appointment));
                            }
                        }
                        start = this.$moment(start).add(1,'days').format('YYYY-MM-DD');
                    }
                    this.$toast.success({
                        message:'Project added',
                        icon: "ti-check"
                    });
                }

			    this.$v.appointment.$reset();
		    }
		    else{
                this.$toast.error({
                    message:'Some fields must be completed',
                    icon: "ti-face-sad"
                });			
		    }
		
		    this.loading_save = false;
        },
        async updateProject(){
            this.$v.appointment.$touch();
            this.loading_save = true;
            if(!this.$v.appointment.$invalid && this.appointment.id_project!==null){
                let result = await this.$api.get('appointment?fields=id_appointment,date&where=id_project='+this.appointment.id_project)
                let app_project = result.data;
                for(let i=0;i<app_project.length;i++){
                    await this.$api.delete('appointment/'+app_project[i].id_appointment)
                }
                let start = this.appointment.date_start;
                while(start <= this.appointment.date_end){
                    if(this.$moment(start).weekday()!==5 
                    && this.$moment(start).weekday()!==6){
                        let temp_appointment = this.appointment;
                        temp_appointment.date = start;
                        temp_appointment.id_appointment = null;
                        let result = await this.$api.post('appointment',temp_appointment);
                        /*if(this.appointment.date == this.$route.params.date){
                            this.appointments.push(await this.getAppointment(result.data.id_appointment));
                        }*/
                        //if date == $route.date
                        let e_update = this.appointments.find(e=>{
                            return e.id_project === this.appointment.id_project;
                        });
                        let current_date = this.$route.params.date;
                        if(e_update!=null){
                            let update = await this.getAppointment(result.data.id_appointment);
                            let is_in_date_range = this.appointment.date_start <= current_date && this.appointment.date_end >= current_date
                            debugger
                            if(is_in_date_range){
                                this.appointments.splice(this.appointments.indexOf(e_update),1,update);
                            }
                            if(this.appointment.id_employee!=this.appointment.current_id_employee || !is_in_date_range){
                                this.appointments.splice(this.appointments.indexOf(e_update),1);
                            }
                        }
                    }
                    start = this.$moment(start).add(1,'days').format('YYYY-MM-DD');
                }

                /*for(let i=0;i<app_project.length;i++) {
                    let temp_appointment = this.appointment;
                    temp_appointment.id_appointment = app_project[i].id_appointment;
                    temp_appointment.date = app_project[i].date;
                    //await this.$api.put('appointment/'+temp_appointment.id_appointment,temp_appointment);
                    await this.$api.post('appointment',temp_appointment);
                }*/

                /*let e_update = this.appointments.find(e=>{
                    return e.id_project === this.appointment.id_project;
                });
                let update = await this.getAppointment(this.appointment.id_appointment);
                this.appointments.splice(this.appointments.indexOf(e_update),1,update);
*/
                this.closeModal();
                this.$toast.success({
                    message:'Project edited',
                    icon: "ti-check"
                });
            }
            else{
                this.$toast.error({
                    message:'Some fields must be completed',
                    icon: "ti-face-sad"
                });			
		    }
            this.loading_save = false;
        },
        async loadAppointmentLog(){
            this.loading_log = true;
            let result = await this.$api.get('appointment/log/'+this.appointment.id_appointment);
            this.log = result.data;
            this.loading_log = false;
        },      
        async printAppointment(){

            let helper = '';
            if(this.day.id_helper_employee!==null){
                let result = await this.$api.get('employee/'+this.day.id_helper_employee);
                helper = result.data.first_name+' '+result.data.last_name;
            }

            pdfMake.vfs = pdfFonts.pdfMake.vfs;

            //let imgObj = new Image();
            //imgObj.src = require('../../assets/img/caslogo.png');
            let imgObj = document.getElementById('img');
            let canvas = document.createElement('canvas');
            canvas.width = imgObj.width; 
            canvas.height = imgObj.height;
            let context = canvas.getContext('2d');
            context.drawImage(imgObj,0,0);

           
            let dd = {
                content: [
                     helper_pdf.get_structure(canvas.toDataURL('image/png'),this.appointment,this.selected_tag_client[0],this.employee,helper)
                ],
                styles: helper_pdf.get_style(),
                pageSize:'A4',
                pageMargins: [ 15, 15, 15, 15 ],
            };
            pdfMake.createPdf(dd).print();
        }
    },
    async beforeMount(){
        let value  = ''
        let result = await this.$api.get('client?where=first_nameLIKE%'+value+'%,||last_nameLIKE%'+value+'%&fields=id_client,first_name,last_name,address,telephone_number');
        this.clients = result.data;
    }
}
</script>
<style src='@voerro/vue-tagsinput/dist/style.css'></style>